import React, { DependencyList } from 'react'

export function useMemoWithDelay<T>(
  fn: () => T,
  delay: number,
  deps: DependencyList,
  initialValue?: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = React.useState(initialValue !== undefined ? initialValue : fn())
  React.useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setValue(fn())
    }, delay)
    return () => window.clearTimeout(timeoutId)
  }, deps)
  return [value, setValue]
}
